import { AdminLearningContentRow, AdminLearningContentRowUpsert } from '../types/domain';

function adminRowToUpsert(row: AdminLearningContentRow): AdminLearningContentRowUpsert {
  return {
    id: row.id,
    workspace_id: row.workspace_id,
    grade_number: row.grade_number,
    sub_category: row.sub_category,
    template_name: row.template_name,
    order_index: row.order_index,
    publisher: row.publisher ?? '',
    track_text: row.track_text ?? '',
    seq_text: row.seq_text ?? '',
    unit_text: row.unit_text ?? '',
    learning_text: row.learning_text ?? '',
    page_text: row.page_text ?? '',
    assistant_page_text: row.assistant_page_text ?? '',
    target_lesson_text: row.target_lesson_text ?? '',
    total_lesson_text: row.total_lesson_text ?? '',
    material_text: row.material_text ?? '',
    achievement_text: row.achievement_text ?? '',
    record_cross_curricular_text: row.record_cross_curricular_text ?? '',
    record_memo_text: row.record_memo_text ?? '',
    record_evaluation_text: row.record_evaluation_text ?? '',
  };
}

/**
 * 출판사 필터로 잘린 표에서 저장된 행을, 동일 편제 전체 행과 같은 순서로 다시 합친다.
 * 원본에서 해당 출판사인 행 위치마다 편집 큐에서 한 행씩 대응시키고, 남은 편집 행은 끝에 붙인다.
 *
 * @param filter 출판사명 trim 값. 빈 문자열이면 출판사 미입력 행만 대상.
 */
export function mergeAdminLearningRowsByPublisherFilter(
  allRows: AdminLearningContentRow[],
  editedForPublisher: AdminLearningContentRowUpsert[],
  filter: string
): AdminLearningContentRowUpsert[] {
  const queue = [...editedForPublisher];
  const out: AdminLearningContentRowUpsert[] = [];
  for (const r of allRows) {
    const rp = (r.publisher ?? '').trim();
    if (rp !== filter) {
      out.push(adminRowToUpsert(r));
    } else {
      const next = queue.shift();
      if (next) {
        out.push({
          ...next,
          id: next.id ?? r.id,
          workspace_id: next.workspace_id ?? r.workspace_id,
          grade_number: next.grade_number ?? r.grade_number,
          sub_category: next.sub_category ?? r.sub_category,
          template_name: next.template_name ?? r.template_name,
          publisher: (next.publisher ?? '').trim() === '' ? r.publisher ?? '' : next.publisher,
        });
      }
    }
  }
  while (queue.length) {
    const next = queue.shift();
    if (next) out.push(next);
  }
  return out.map((row, idx) => ({ ...row, order_index: idx }));
}
